module.exports = __webpack_public_path__ + "img/video-action.aee420de.png";